const dev = {
  baseURL: "http://localhost:8074",
};

const prod = {
  baseURL: "https://hbmarket.matjarepos.com",
};

const config = process.env.NODE_ENV === "production" ? prod : dev;

export default config;